import { KeyboardSensor, MouseSensor, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import { CSS } from '@dnd-kit/utilities'

export const useDraggableSensors = ({ delay = 100, tolerance = 5 } = {}) => {
  return useSensors(
    useSensor(MouseSensor, {
      activationConstraint: {
        delay,
        tolerance,
      },
    }),
    useSensor(PointerSensor, {
      activationConstraint: {
        delay,
        tolerance,
      },
    }),
    useSensor(KeyboardSensor),
  );
};

export const dropAnimationConfig = {
  keyframes({ transform }) {
    return [
      { transform: CSS.Transform.toString(transform.initial) },
      {
        transform: CSS.Transform.toString({
          ...transform.final,
          scaleX: 1,
          scaleY: 1
        })
      }
    ]
  },
  sideEffects({ active, dragOverlay }) {
    active.node.style.opacity = "0"

    const button = dragOverlay.node.querySelector(".cs-content-card")

    if (button) {
      button.animate(
        [
          {
            boxShadow:
              "-1px 0 15px 0 rgba(34, 33, 81, 0.01), 0px 15px 15px 0 rgba(34, 33, 81, 0.25)"
          },
          {
            boxShadow:
              "-1px 0 15px 0 rgba(34, 33, 81, 0), 0px 15px 15px 0 rgba(34, 33, 81, 0)"
          }
        ],
        {
          duration: 1000,
          easing: "ease-in-out",
          fill: "forwards"
        }
      )
    }

    return () => {
      active.node.style.opacity = ""
    }
  }
}